<template>
    <div class="matics">
        <viewer :images="urls">
            <template v-for="(a,i) in urls">
              <!-- <img  v-lazy="a" v-if="i<=13"> -->
                <img  :src="a" v-if="i<=13">
            </template>
        </viewer>
    </div>
</template>

<script>
  export default {
    name: "matics",
    components: {},
    data() {
      return{
        urls: [
          require(`../../assets/images/fg/0.png`),
          require(`../../assets/images/fg/1.png`),
          require(`../../assets/images/fg/2.png`),
          require(`../../assets/images/fg/3.png`),
          require(`../../assets/images/fg/4.png`),
          require(`../../assets/images/fg/5.png`),
          require(`../../assets/images/fg/6.png`),
          require(`../../assets/images/fg/7.png`),
          require(`../../assets/images/fg/8.png`),
          require(`../../assets/images/fg/9.png`),
          require(`../../assets/images/fg/10.png`),
          require(`../../assets/images/fg/11.png`),
          require(`../../assets/images/fg/12.png`),
          require(`../../assets/images/fg/13.png`),
        ]
      }
    },
    mounted() {
      const imgTotal=13;
      for (let i = 0; i < imgTotal; i++) {
        let url = require(`../../assets/images/fg/${i}.png`);
        this.urls.push(url);
      }

    }
  }
</script>

<style scoped lang='less'>
.matics{
  max-width: 950px;
  margin:0 auto;
  img{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// matics.vue?42355d0e